import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10.125.5V0H10C4.5 0 0 4.5 0 10h.5c5.375.125 9.625-4.25 9.625-9.5z',
    'M.5 10H0c0 5.5 4.5 10 10 10h.125v-.375C10 14.375 5.75 10 .5 10zM19.75 10H20c0-5.5-4.375-10-9.875-10v.375C10.125 5.625 14.5 10 19.75 10zM10.125 19.625V20c5.375-.125 9.75-4.5 9.875-10h-.25c-5.25 0-9.625 4.375-9.625 9.625z',
  ],
  height: 20,
  width: 20,
});
